import { extendObservable, action, computed } from 'mobx';
import { STATUS } from 'react-joyride';

/**
 * @typedef {import("react-joyride").Locale} Locale
 * @typedef {import("react-joyride").Props} JoyrideProps
 */

const defaultStyles = {
  'ig-green-color': '#0fa69a'
};

class TooltipStore {
  /** Description of the function
   * @callback getStepsFun
   * @param {String} section Section to be shown.
   * @param {Object} intl React intl object linke to translate.
   * @param {Object} user User, if need to show somehting on front about him/her.
   * @returns {(import("react-joyride").Step)[]} steps array ready to be shown on front.
   */

  /**
   * @param {Object} rootStore
   * @param {Object} param1
   * @param {getStepsFun} param1.getSteps Funct used to get steps according to section.
   * @param {Object} param1.sections Key - value sections object.
   */
  constructor(rootStore, { getSteps, sections } = {}) {
    this.rootStore = rootStore;
    this.getSteps = getSteps;

    extendObservable(this, {
      sections,
      currentSection: sections.default,
      runState: false,
      keyHack: 0,
      _mountFunc: undefined
    });
  }

  /**
   * @description return steps to be used
   * @returns {(import("react-joyride").Step)[]}
   */
  @computed get steps() {
    const { intl } = this.rootStore.localeStore;
    const { user } = this.rootStore;

    return this.getSteps(this.currentSection, intl, user);
    // .filter(el => {
    //   return el.target && document.getElementsByName(el.target);
    // });
  }

  /**
   * @description Yeah, you comming?
   * @returns {boolean}
   */
  @computed get run() {
    return this.runState;
  }

  /**
   * @description get react joyride locales data.
   * @returns {Locale}
   */
  @computed get locales() {
    const { intl } = this.rootStore.localeStore;

    return {
      back: intl.formatMessage({ id: 'back' }),
      close: intl.formatMessage({ id: 'close' }),
      last: intl.formatMessage({ id: 'last' }),
      next: intl.formatMessage({ id: 'next' }),
      skip: intl.formatMessage({ id: 'skip' })
    };
  }

  /**
   * @description Default tooltip JoyrideProps we will be using
   * @returns {JoyrideProps}
   */
  @computed get joyrideProps() {
    return {
      callback: this.handleJoyrideCallback,
      locale: this.locales,
      run: this.run,
      steps: this.steps,
      continuous: true,
      scrollToFirstStep: true,
      // showProgress: true,
      showSkipButton: true,
      key: this.keyHack,
      styles: { options: { primaryColor: defaultStyles['ig-green-color'] } }
    };
  }

  /**
   * @description Set current section to show on Tour and show it.
   * @param {string} section section to be shown on tour.
   * @param {boolean} run Should tour be taken inmediatly?
   */
  @action setCurrentSection = (section, run) => {
    this.currentSection = section;
    this.runState = false;

    this.restartTour();

    if (run) {
      this.takeTour();
    }
  };

  /**
   * @description Take tour.
   */
  @action takeTour = () => {
    this.runState = true;

    this.restartTour();
  };

  /** https://github.com/gilbarbara/react-joyride/issues/354#issuecomment-388473648
   *
   * @description Take tour from the beginning. Using controlled components.
   */
  @action restartTour = () => {
    this.keyHack += 1;
  };

  @action handleJoyrideCallback = (data) => {
    const { status, type } = data; // eslint-disable-line no-unused-vars

    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      this.runState = false;
    }

    // console.groupCollapsed(type);
    // console.log(data); // eslint-disable-line no-console
    // console.groupEnd();
  };

  @action setMountFunc = (func) => {
    this._mountFunc = func;
  };

  @action
  mountFunc = () => {
    if (this._mountFunc) {
      // TODO: FIX. Fast solution to inmediate problem with mvp tooltips.
      setTimeout(() => {
        this._mountFunc();
      }, 500);
    }
  };
}

export default TooltipStore;
